import { useModal } from '@/app/Providers/ModalContext'
import { ToastAction } from '@/app/Providers/Toast/Toast'
import Button from '@/components/Button'
import { sessionLogs } from '@/services/logs'
import { sendIsolatedErrorMessageSlackNotification } from '@/services/notifier'
import * as React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/v2/Dialog'
import { Label } from '@/components/ui/label'
import Card from '@/components/Card'

function DetailsPopup() {
  const { setContent, close } = useModal()
  const [sent, setSent] = React.useState(false)
  const [sending, setSending] = React.useState(false)

  console.log({ sent, sending })

  return (
    <Card className="p-4 w-2/3 m-auto">
      <p className="text-lg font-bold mb-2">Detalhes do erro</p>

      <p>Este é um erro inesperado no processo de assinatura local.</p>
      <p>
        As causas podem ser várias, desde problemas no certificado até erro de
        acesso por parte do assistente de assinaturas.
      </p>

      <p className="mt-2">
        Você pode nos enviar os dados de diagnóstico ou apenas baixar os logs de
        erro para seu dispositivo.
      </p>

      <div className="mt-4 flex flex-col gap-4">
        <Button
          variant="light-gray"
          className="w-full"
          onClick={() => sessionLogs.download()}
        >
          Baixar logs de erro
        </Button>
        <Button
          className="w-full"
          variant="default"
          loading={sending}
          disabled={sent}
          onClick={async () => {
            setSending(true)
            try {
              await sendIsolatedErrorMessageSlackNotification(
                `Erro inesperado no SignAssistant: (últimos 20 registros) ${JSON.stringify(
                  sessionLogs.getJson(20),
                )}`,
              )
            } catch (error) {
              await sendIsolatedErrorMessageSlackNotification(
                `Erro ao enviar logs de erro do SignAssistant`,
              )
            }
            setSending(false)
            setSent(true)
          }}
        >
          {(() => {
            if (sent) return '✅ Dados enviados'
            return sending ? 'Enviando...' : 'Enviar dados de diagnóstico'
          })()}
        </Button>
      </div>
    </Card>
  )
}

export function DialogDemo() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {/* <Button variant="outline">Edit Profile</Button> */}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit profile</DialogTitle>
          <DialogDescription>
            Make changes to your profile here. Click save when youre done.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="name" className="text-right">
              Name
            </Label>
            {/* <Input id="name" value="Pedro Duarte" className="col-span-3" /> */}
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Username
            </Label>
            {/* <Input id="username" value="@peduarte" className="col-span-3" /> */}
          </div>
        </div>
        <DialogFooter>
          <Button type="submit">Save changes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default function SignAssistantErrorToastAction() {
  const { setContent, close } = useModal()

  return (
    <ToastAction
      onClick={() => {
        setContent(<DetailsPopup />)
      }}
      altText="Exportar logs de erro"
    >
      Detalhes
    </ToastAction>
  )
}
